<template>
	<div class="equipmentManagement ">
		<div class="itemTitleBox disStart">
			<span class="title">设备管理</span>
			<el-upload class="upload-demo" ref="upload" :headers="headers"
				action="charge/communityEquipment/upLoadExcelData" :on-success="onSuccess" :before-upload="beforeUpload"
				:show-file-list="NOfalse" :limit="limitNum" :on-error="onError">
				<span class="iconBox icon_dr" title="导入设备"></span>
			</el-upload>
		</div>
		<div class="BtnBox disBetween">
			<div class="searchBox disBetween">
				<div class="myinputBox">
					<el-input clearable v-model="searchObj.communityEquipmentNo" placeholder="请输入设备编号"></el-input>
				</div>
				<!-- <div class="myinputBox">
					<div class="myinputBox">
						<el-select clearable v-model="searchObj.communitySiteId" slot="prepend" placeholder="请选择充电站">
							<el-option v-for="(item,inx) in stationList" :key="inx" :label="item.communitySiteName"
								:value="item.communitySiteId"></el-option>
						</el-select>
					</div>
				</div> -->
				<div class="myinputBox">
					<el-select clearable v-model="searchObj.equipmentStatus" slot="prepend" placeholder="请选择设备状态">
						<el-option v-for="(item,inx) in equStatusList" :key="inx" :label="item.text"
							:value="item.value"></el-option>
					</el-select>
				</div>
				<div class="myinputBox">
					<el-select clearable v-model="searchObj.equipmentRunStatus" slot="prepend" placeholder="请选择运营状态">
						<el-option v-for="(item,inx) in operateStatusList" :key="inx" :label="item.text"
							:value="item.value"></el-option>
					</el-select>
				</div>
				<el-button type="success" @click="toSearch">查询</el-button>
			</div>

			<!-- <div class="icon_add upIcon" @click="updateEqu" title="设备升级"></div> -->
		</div>
		<div class="listBox">
			<div style="height: 100%;width: 100%;" v-if="tableData && tableData.length>0" v-loading="loading">
				<div class="content myTable">
					<el-table ref="multipleTable" :row-key="(row) => row.communityEquipmentNo" :data="tableData" stripe
						style="width: 100%" @selection-change="handleInfaceSelectionChange">
						<!-- <el-table-column type="selection" :reserve-selection="true" :selectable="handleDisable"
							width=" 55">
						</el-table-column> -->
						<!-- 	<el-table-column type="selection" width="55">
						</el-table-column> -->
						<el-table-column type="index" label="序号" width="50">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="设备编号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communitySiteName" label="设备位置">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="使用率(日)" width="100">
							<template slot-scope="scope">
								<div class="clickUndline" @click="showPower(scope.row)">
									<span class="green"
										v-if=" scope.row.dayUseCount>=5 ">{{((scope.row.dayUseCount/10)*100).toFixed(0)}}%</span>
									<span class="orange"
										v-if="scope.row.dayUseCount>=3 && scope.row.dayUseCount<5">{{((scope.row.dayUseCount/10)*100).toFixed(0)}}%</span>
									<span class="red"
										v-if="scope.row.dayUseCount<3">{{((scope.row.dayUseCount/10)*100).toFixed(0)}}%</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="dayUseCount" label="充电次(日)" width="100">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="monthUserCount" label="充电次(月)" width="100">
						</el-table-column>
						<!-- <el-table-column show-overflow-tooltip prop="yearUseCount" label="充电次(年)">
						</el-table-column> -->

						<!-- <el-table-column show-overflow-tooltip prop="communityEquipmentName" label="设备名称" width="90">
						</el-table-column> -->
						<!-- <el-table-column show-overflow-tooltip prop="communitySiteName" label="所属站点" width="90">
						</el-table-column> -->
						<el-table-column prop="equipmentStatus" label="状态" width="130">
							<template slot-scope="scope">
								<span v-if="scope.row.equipmentInstallStatus==1">未安装</span>
								<span v-else>{{getName(scope.row.equipmentStatus,equStatusList)}}
									<span
										v-if="scope.row.equipmentStatus==2 && scope.row.unlineFlag">({{getName(scope.row.unlineFlag,unlineFlagList)}})</span>
								</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="unlineCount" label="离线次数" width="70">
							<template slot-scope="scope">
								<div class="clickUndline" @click="showUnlineCount(scope.row)">
									{{scope.row.unlineCount}}
								</div>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentJackNumber" label="插座" width="70">
						</el-table-column>
						<!-- <el-table-column show-overflow-tooltip prop="equipmentServiceProvider" label="运营商" width="100">
						</el-table-column> -->
						<!-- <el-table-column prop="equipmentRunStatus" label="运营状态" width="70">
							<template slot-scope="scope">
								<span>{{getName(scope.row.equipmentRunStatus,operateStatusList)}}</span>
							</template>
						</el-table-column> -->
						<el-table-column prop="operate" label="操作" width="50" fixed="right">
							<template slot-scope="scope">
								<el-popover class="mypopover disCenter" placement="top-end" width="100" trigger="hover">
									<div class="pupBox">
										<span class="hoverClass" @click.stop="itemClick(scope.row,3)">二维码</span>
										<span class="hoverClass" @click.stop="itemClick(scope.row,9)">功率配置</span>
										<span class="hoverClass" @click.stop="itemClick(scope.row,2)">运维记录</span>
										<span class="hoverClass" @click.stop="itemClick(scope.row,6)">充电记录</span>
										<span class="hoverClass" @click.stop="itemClick(scope.row,1)">详情</span>
										<!-- <span class="hoverClass" @click.stop="itemClick(scope.row,5)">解绑</span> -->
										<!-- <span class="hoverClass" @click.stop="itemClick(scope.row,7)">复位</span> -->
										<!-- <span class="hoverClass" @click.stop="itemClick(scope.row,4)">删除</span> -->
									</div>
									<div slot="reference" class="itemRight listIcon"></div>
								</el-popover>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange($event,1)">
					</el-pagination>
				</div>
			</div>
			<div v-else class="nodataBox">
				<nodata :str="str">
					<template v-slot>
						<div class="slotBox">
							<!-- <div class="disStart" @click="openDia(5)" title="新建设备">
								<span class="icon_add2"></span>
								<span>新建设备</span>
							</div> -->
							<el-upload class="upload-demo" ref="upload" :headers="headers"
								action="charge/communityEquipment/upLoadExcelData" :on-success="onSuccess"
								:before-upload="beforeUpload" :show-file-list="NOfalse" :limit="limitNum"
								:on-error="onError">
								<div class="disStart">
									<span class="icon_dr"></span>
									<span>一键导入</span>
								</div>
							</el-upload>
						</div>
					</template>
				</nodata>
			</div>
		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="75%">
			<div class="disBetween diaBtnBox">
				<span class="" title="解绑" v-if="creatObj.communityId" @click.stop="itemClick(creatObj,5)">解绑</span>
				<span class="" title="复位" @click.stop="itemClick(creatObj,7)">复位</span>
			</div>
			<el-form :model="creatObj" :rules="rules" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="设备编号">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.communityEquipmentNo" placeholder="请输入设备编号">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="所属社区">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.communityName" placeholder="请输入社区名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">

						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="运营状态">
								<div class="myinputBox">
									<el-select clearable disabled v-model="creatObj.equipmentRunStatus" slot="prepend"
										placeholder="请选择运营状态">
										<el-option v-for="(item,inx) in operateStatusList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="IP地址">
								<div class="myinputBox">
									<el-input clearable disabled v-model="creatObj.communityEquipmentIp"
										placeholder="请输入IP地址">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="最小功率" >
								<div class="myinputBox">
									<el-input clearable disabled v-model="creatObj.equipmentMinPower"
										placeholder="">
										<template slot="append">W</template>
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="最大功率">
								<div class="myinputBox">
									<el-input clearable disabled v-model="creatObj.equipmentMaxPower"
										placeholder="">
										<template slot="append">W</template>
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">

						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="插座规格">
								<div class="myinputBox">
									<el-input clearable disabled v-model="creatObj.equipmentJackNumber"
										placeholder="请输入插座规格">
										<template slot="append">路</template>
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="安装日期">
								<div class="myinputBox">
									<el-date-picker disabled value-format="yyyy-MM-dd"
										v-model="creatObj.equipmentInstallTime" type="date" placeholder="选择日期">
									</el-date-picker>
								</div>
							</el-form-item>
						</div>
					</div>

					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="安装状态">
								<div class="myinputBox">
									<el-select disabled v-model="creatObj.equipmentInstallStatus" slot="prepend"
										placeholder="请选择安装状态">
										<el-option v-for="(item,inx) in equipmentInstallStatusList" :key="inx"
											:label="item.text" :value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="设备状态">
								<div class="myinputBox">
									<el-select disabled v-model="creatObj.equipmentStatus" slot="prepend"
										placeholder="请选择安装状态">
										<el-option v-for="(item,inx) in equStatusList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween" v-if="creatObj.equipmentStatus==2">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="离线时间">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.unlineTime" placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="离线理由">
								<div class="myinputBox">
									<el-select disabled v-model="creatObj.unlineFlag" slot="prepend" placeholder="">
										<el-option v-for="(item,inx) in unlineFlagList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween" v-else>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="上次离线时间" prop="unlineTime">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.unlineTime" placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="设备位置">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.communitySiteName" placeholder="请输入设备位置">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem" v-if="creatObj.equipmentStatus==1">
						<div class="diaTpye disStart">
							插座状态
						</div>
						<div class="czBox disStart">
							<div class="czItem disStart" v-for="(item,inx) in creatObj.equipmentPortList" :key="inx">
								<div class="disStart">
									<span>插座{{item.communityEquipmentPort}}：</span>
									<span
										:class="item.portStatus==1?'blue':item.portStatus==2?'green':item.portStatus==3?'red':''">{{item.portStatus==1?"空闲":item.portStatus==2?"使用中":item.portStatus==3?"故障":""}}</span>
									<span class="czIcon" title="复位" @click="itemClick(item,8)"></span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="toSave">保 存</el-button>
			</span> -->
				<!-- <el-form-item class="diabtnBox disCenter">
					<el-button type="primary" @click="dialogVisible=false">确定</el-button>
				</el-form-item> -->
			</el-form>
		</el-dialog>
		<el-dialog title="设备二维码" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="equipmentCard"
			width="60%">
			<div class="dialogBox dialogBox2">
				<div class="cardBox disCenter">
					<img :src="cardUrl" alt="" sizes="" srcset="">
				</div>
			</div>
		</el-dialog>
		<el-dialog title="运维记录" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogOperation"
			width="60%">
			<div class="dialogBox dialogBox2">
				<div class="diaItem disBetween">
					<div class="myinputBox">
						<el-date-picker v-model="OperationObj.searchData" type="daterange" range-separator="~"
							value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</div>
					<el-button type="success" @click="getoperationData">查询</el-button>
				</div>
				<div class="myTable" v-loading="loading2">
					<el-table :data="operationData" style="width: 100%">
						<el-table-column type="index" label="序号" width="70">
						</el-table-column>
						<el-table-column prop="value1" label="检修时间" width="90">
							<template slot-scope="scope">
								<span class="spanText">{{scope.row.value1}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="value2" label="检修人员" width="140">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="value3" label="联系方式" width="140">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="value4" label="检修类型" width="140">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="value5" label="检修状态" width="140">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="value6" label="检修结果" width="140">
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination mypagination  mypagination2">
					<el-pagination background small :page-size="OperationInfo.pagesize"
						:current-page="OperationInfo.pagenum" :total="OperationInfo.total" :pager-count="5"
						prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange($event,2)">
					</el-pagination>
				</div>

			</div>
		</el-dialog>
		<el-dialog :title="echartsTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="showPowerEcharts" width="90%">
			<div class="dialogBox1">
				<div class="disStart">
					<div class="diaItem ">
						<div class="timeType disStart">
							<span class="disCenter" :class="{active:active==1}" @click="active=1">月</span>
							<span class="disCenter" :class="{active:active==2}" @click="active=2">年</span>
						</div>
						<div class="myinputBox myinputBox2">
							<el-date-picker v-show="active==1" :clearable="NOfalse" :editable="NOfalse"
								v-model="searchMonth" value-format="yyyy-MM" type="month" placeholder="选择日期">
							</el-date-picker>
							<el-date-picker v-show="active==2" :clearable="NOfalse" :editable="NOfalse"
								v-model="searchYear" value-format="yyyy" type="year" placeholder="选择日期">
							</el-date-picker>
						</div>
						<el-button type="success" @click="getEcharts">查询</el-button>
					</div>
				</div>
				<div v-loading="echartLoading" class="statisticalRight" id="myEcharts2"></div>
			</div>
		</el-dialog>
		<el-dialog title="离线记录" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogOperation3"
			width="80%">
			<div class="dialogBox dialogBox3">
				<div class="myTable myTable2">
					<el-table :data="operationData"  height="400" stripe style="width: 100%" v-loading="undeloading">
						<el-table-column type="index" label="序号" width="50">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentId" label="设备ID">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentNo" label="设备编号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="unlineTime" label="离线时间">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="unlineFlag" label="离线理由">
							<template slot-scope="scope">
								<span>{{getName(scope.row.unlineFlag,unlineFlagList)}}</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="充电功率(W)" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="visibleShow1"
			width="40%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm5" label-width="100px" class="demo-ruleForm">
				<div class=" dialogBox5">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="最小功率" prop="equipmentMinPower">
								<div class="myinputBox">
									<el-input @input="numberChange(creatObj.equipmentMinPower,2000,1)" v-model="creatObj.equipmentMinPower"
										type="text" placeholder="请输入最低充电功率" oninput="value=value.replace(/[^\d]/g,'')">
										<template slot="append"></template></el-input>
									<!-- <el-select clearable v-model="creatObj.equipmentMinPower" slot="prepend"
										placeholder="请选择最低输出功率">
										<el-option v-for="(item,inx) in minList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select> -->
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="最大功率" prop="equipmentMaxPower">
								<div class="myinputBox">
									<el-input @input="numberChange(creatObj.equipmentMaxPower,2000,2)" v-model="creatObj.equipmentMaxPower"
										type="text" placeholder="请输入最低充电功率" oninput="value=value.replace(/[^\d]/g,'')">
										<template slot="append"></template></el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="visibleShow1=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm5')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import nodata from "../../../nodata/nodata.vue"
	import {
		timestampToDate
	} from "../../../../assets/js/common.js"
	var token = localStorage.getItem('token')
	export default {
		name: "equipmentManagement",
		components: {
			nodata
		},
		data() {
			var checkNum = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入插座规格'));
				}
				setTimeout(() => {
					if (isNaN(parseFloat(value))) {
						callback(new Error('请输入数字值'));
					} else {
						callback();
					}
				}, 500);
			};
			var checkIp = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入IP地址'));
				}
				setTimeout(() => {
					var reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
					if (reg.test(value)) {
						callback();
					} else {
						callback(new Error('请输入正确的ip地址'));
					}
				}, 500);
			};
			return {
				dialogOperation3: false,
				undeloading: false,
				operationData: [],
				str: "您还没有相应的设备,请新建设备",
				limitNum: 1,
				cardUrl: "",
				headers: {
					Authorization: token,
					token: token
				},
				active: 1,
				searchMonth: "",
				searchYear: "",
				showPowerEcharts: false,
				echartsTitle: "设备使用率",
				selectionArr: [],
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				OperationInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				searchObj: {
					communityId: "", //社区编号
					communitySiteId: "",
					communityEquipmentNo: "",
					equipmentStatus: "",
					equipmentRunStatus: "",
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
				},
				restaurants: [],
				OperationObj: {
					pagesize: 10,
					pagenum: 1,
					searchData: [], //运维搜索时间
				},
				stationList: [],
				equStatusList: [{
						text: "正常",
						value: 1
					},
					{
						text: "离线",
						value: 2
					},
					{
						text: "故障",
						value: 3
					},
				],
				equipmentInstallStatusList: [{
						text: "未安装",
						value: 1
					},
					{
						text: "已安装",
						value: 2
					},

				],
				unlineFlagList: [{
						text: "设备自动断电",
						value: 1
					},
					{
						text: "检测不到心跳",
						value: 2
					}
				],
				operateStatusList: [{
						text: "未投用",
						value: 1
					},
					{
						text: "运营中",
						value: 2
					},
					{
						text: "已拆除",
						value: 3
					},
				],
				tableData: [],
				operationData: [],
				NOfalse: false,
				dialogTitle: "新建设备",
				dialogVisible: false,
				visibleShow1: false,
				equipmentCard: false,
				dialogOperation: false,
				creatObj: {
					communityId: "", //社区id
					communityName: "", //社区名称
					communitySiteId: "", //站点id
					communityEquipmentNo: "", //设备硬件编号
					communityEquipmentName: "", //设备名称
					communityEquipmentIp: "", //设备ip
					equipmentJackNumber: "", //设备插座
					equipmentServiceProvider: "", //设备运营商
					equipmentStatus: "", //设备状态 1正常 2故障 3掉线
					equipmentRunStatus: "", //设备运营状态 1未投用 2运营中 3已拆除
					equipmentInstallTime: "" //安装时间
				},
				loading: false,
				loading2: false,
				echartLoading: false,
				communityObj: {},
				equipmentObj: {},
				rules: {
					communityEquipmentNo: [{
						required: true,
						message: '请输入设备编号',
						trigger: 'blur'
					}],
					communityEquipmentName: [{
						required: true,
						message: '请输入设备名称',
						trigger: 'blur'
					}],
					communityEquipmentIp: [{
							validator: checkIp,
							trigger: 'blur'

						},
						{
							required: true,
							message: '请输入IP地址',
							trigger: 'blur'
						}
					],
					equipmentJackNumber: [{
							validator: checkNum,
							trigger: 'blur'
						},
						{
							required: true,
							message: '请输入插座规格',
							trigger: 'blur'
						}
					],
					equipmentServiceName: [{
						required: true,
						message: '请输入运营商名称',
						trigger: 'change'
					}],
					communitySiteName: [{
						required: true,
						message: '请输入设备位置',
						trigger: 'change'
					}],
					equipmentRunStatus: [{
						required: true,
						message: '请选择运营状态',
						trigger: 'change'
					}],
					equipmentInstallTime: [{
						required: true,
						message: '请选择安装日期',
						trigger: 'change'
					}],
					equipmentInstallStatus: [{
						required: true,
						message: '请选择安装状态',
						trigger: 'change'
					}],
					equipmentMinPower: [{
						required: true,
						message: '请输入最低充电功率',
						trigger: 'blur'
					}],
					equipmentMaxPower: [{
						required: true,
						message: '请输入最大充电功率',
						trigger: 'blur'
					}],
				},
			}
		},
		mounted() {
			// this.selectParamConfigByCode()
			let time = new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000
			this.$set(this, "searchMonth", timestampToDate(new Date()).slice(0, 7))
			this.$set(this, "searchYear", timestampToDate(new Date()).slice(0, 4))
			this.OperationObj.searchData = [timestampToDate(time), timestampToDate(new Date().getTime())]
		},
		methods: {
			showUnlineCount(item) {
				this.$api.listUnlineRecord({
					communityEquipmentNo: item.communityEquipmentNo
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "operationData", res.obj)
						this.dialogOperation3 = true
					}
				})
				// undeloading:false
			},
			showPower(obj) {
				this.echartsTitle = "使用率曲线图（" + obj.communityEquipmentNo + "）"
				this.$set(this, "equipmentObj", obj)
				this.getEcharts()
			},
			getEcharts() {
				this.echartLoading = true
				let time = ""
				if (this.active == 1) {
					time = this.searchMonth
				} else {
					time = this.searchYear
				}
				let item = {
					xDate: [],
					data: []
				}
				let arr = []
				this.showPowerEcharts = true
				this.$api.selectEquipmentUsedByEquipmentIdAndDateType({
					dateType: this.active,
					date: time,
					communityEquipmentId: this.equipmentObj.communityEquipmentId
				}).then((res) => {
					if (res.returnCode == 200) {
						this.echartLoading = false
						if (res.obj.usedList && res.obj.usedList.length > 0) {
							this.showPowerEcharts = true
							for (let k in res.obj.dateList) {
								if (this.active == 1) {
									this.$set(res.obj.dateList, [k], res.obj.dateList[k] + "号")
								} else {
									this.$set(res.obj.dateList, [k], res.obj.dateList[k] + "月")
								}
							}
							this.$set(item, "xDate", res.obj.dateList || [])
							this.$set(item, "data", res.obj.usedList || [])
							this.$nextTick(() => {
								this.showEchart(item)
							})
						}
					}
				})
			},
			showEchart(item) {
				let that = this
				let getchart = that.$echarts.init(document.getElementById('myEcharts2'));
				getchart.clear()
				var option = {
					tooltip: {
						trigger: "axis",
						valueFormatter: function(value) {
							return value + "%"
						}
					},
					grid: {
						top: "8%",
						left: "1%",
						right: "4%",
						bottom: "8%",
						containLabel: true,
					},
					xAxis: [{
						type: "category",
						axisLine: {
							lineStyle: {
								color: "#90979c",
							},
						},
						splitLine: {
							show: false,
						},

						splitArea: {
							show: false,
						},
						data: item.xDate,
					}, ],
					yAxis: [{
						name: "使用率：%",
						type: "value",
						min: that.min,
						axisLine: {
							lineStyle: {
								color: "#90979c",
							},
						},

					}, ],
					dataZoom: [{
							show: true,
							height: 30,
							xAxisIndex: [0],
							bottom: -60,
							start: 0,
							end: that.end,
						},
						{
							type: "inside",
							show: true,
							height: 15,
							start: 1,
							end: 50,
						},
					],
					series: [{
						name: "使用率",
						type: "line",
						smooth: true, //是否平滑曲线显示
						symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
						symbolSize: 10,
						lineStyle: {
							normal: {
								color: "#03adac", // 线条颜色
							},
						},
						data: item.data,
					}, ],
				};

				getchart.setOption(option);
			},
			selectParamConfigByCode() {
				this.$api.selectParamConfigByCode({
					"paramCode": 1002,
					"search": ""
				}).then((res) => {
					if (res.returnCode == 200) {
						for (let k of res.obj.paramConfigItemList) {
							this.restaurants.push({
								value: k.paramConfigItemName,
								id: k.paramConfigItemId
							})
						}

					}
				})

			},

			handleSelect(item) {
				this.$set(this.creatObj, "equipmentServiceName", item.value)
				this.$set(this.creatObj, "equipmentServiceProvider", item.id)
			},
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return (restaurant) => {
					return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
				};
			},
			// 改变站点列表  选择器
			setStationList(id) {
				this.$api.listAllCommunitySiteByCommunityId({
					communityId: id
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this.searchObj, "communitySiteId", '')
						this.$set(this, "stationList", res.obj)
					}
				})
			},
			// 打开新增站点弹窗
			toCreate() {
				this.$emit("moduleThree")
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			updateEqu() {},
			handleInfaceSelectionChange(val) {
				this.selectionArr = [];
				let a = val;
				if (a.length > 0) {
					a.forEach((item) => {
						this.selectionArr.push(item.communityEquipmentId);
					});
				}
			},
			handleDisable(row) {
				if (row.submitState == 1) {
					return false;
				} else {
					return true;
				}
			},
			// 1编辑 5新增
			openDia(n, item) {
				if (n == 1) { //详情
					this.dialogTitle = "设备信息"
					this.getselectCommunityEquipment(item.communityEquipmentId,item)
				} else if (n == 5) { //新增
					this.dialogTitle = "新建设备"
					this.$set(this, "creatObj", {
						communityEquipmentNo: "",
						communityEquipmentName: "",
						communitySiteId: "",
						communityName: this.searchObj.communityName,
						communityId: this.searchObj.communityId,
						equipmentJackNumber: "",
						equipmentServiceProvider: "",
						communitySiteName: "",
						equipmentRunStatus: "",
						equipmentInstallTime: "",
						equipmentInstallStatus: 1,
					})
					this.dialogVisible = true
					this.$nextTick(() => {
						this.$refs.ruleForm3.clearValidate()
					})
				}

			},
			// 获取运维数据
			getoperationData(n) {
				// this.loading2 = true
				if (n) {
					this.OperationObj.pagenum = n
				} else {
					this.OperationObj.pagenum = 1
					this.dialogOperation = true
				}
				this.$api.listCommunityEquipment(this.OperationObj).then((res) => {
					if (res.returnCode == 200) {
						this.loading2 = false
						this.$set(this, "operationData", res.obj.list)
						this.$set(this.OperationInfo, "total", res.obj.total)
					}
				})
			},
			numberChange(val, maxNum, n) {
				if (n == 1) {
					//转换数字类型
					let num = Number(val)
					// if (num < 1) {
					// 	this.$set(this.creatObj, "equipmentMinPower", 1)
					// }
					if (num > 2000) {
						this.$set(this.creatObj, "equipmentMinPower", 2000)
					}
				} else if (n == 2) {
					//转换数字类型
					let num = Number(val)
					// if (num < 1) {
					// 	this.$set(this.creatObj, "equipmentMaxPower", 1)
					// }
					if (num > 2000) {
						this.$set(this.creatObj, "equipmentMaxPower", 2000)
					}
				}
			
			},
			// 获取设备信息
			getselectCommunityEquipment(id,item) {
				this.$api.selectCommunityEquipment({
					communityEquipmentId: id
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "creatObj", {
							communityEquipmentNo: res.obj.communityEquipmentNo,
							communityEquipmentName: res.obj.communityEquipmentName,
							communitySiteId: res.obj.communitySiteId,
							communityEquipmentIp: res.obj.communityEquipmentIp,
							equipmentJackNumber: res.obj.equipmentJackNumber,
							equipmentServiceName: res.obj.equipmentServiceProvider,
							equipmentServiceProvider: res.obj.equipmentServiceProviderId,
							equipmentRunStatus: res.obj.equipmentRunStatus,
							equipmentInstallTime: res.obj.equipmentInstallTime,
							communityEquipmentId: res.obj.communityEquipmentId,
							communitySiteName: res.obj.communitySiteName,
							communityName: res.obj.communityName,
							communityId: res.obj.communityId,
							equipmentStatus: res.obj.equipmentStatus,
							unlineTime: res.obj.unlineTime,
							unlineFlag: res.obj.unlineFlag,
							equipmentMinPower: item.equipmentMinPower/10,
							equipmentMaxPower: item.equipmentMaxPower/10,
							equipmentPortList: res.obj.equipmentPortList || [],
							equipmentInstallStatus: res.obj.equipmentInstallStatus || 1,
						})
						this.dialogVisible = true
						this.$nextTick(() => {
							this.$refs.ruleForm3.clearValidate()
						})
					}
				})
			},
			// 按钮保存 新增/编辑
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						// if (this.dialogTitle == "新建设备") {
						// 	this.addCommunityEquipment()
						// } else {
						// 	this.updateCommunityEquipment()
						// }
						if (formName == "ruleForm5"){
							if(Number(that.creatObj.equipmentMinPower)<=0){
								that.$message({
									type: 'warning',
									message: '请输入最小充电功率!'
								});
								return false
							}
							if(Number(that.creatObj.equipmentMaxPower)<=0){
								that.$message({
									type: 'warning',
									message: '请输入最大充电功率!'
								});
								return false
							}
							if(Number(that.creatObj.equipmentMinPower)>=Number(that.creatObj.equipmentMaxPower)){
								that.$message({
									type: 'warning',
									message: '最小充电功率不能低于最大充电功率!'
								});
								return false
							}
							that.$set(that.creatObj, "equipmentMaxPower", (JSON.parse(JSON.stringify(that.creatObj)).equipmentMaxPower)*10)
							that.$set(that.creatObj, "equipmentMinPower", (JSON.parse(JSON.stringify(that.creatObj)).equipmentMinPower)*10)
							that.$api.updateCommunityEquipment(that.creatObj).then((res) => {
								if (res.returnCode == 200) {
									that.$message({
										type: 'success',
										message: '充电功率配置成功!'
									});
									that.visibleShow1 = false
									setTimeout(() => {
										that.getData({})
										that.rushData()
									}, 500)
								}
							})
						}
					} else {
						return false;
					}
				});
			},
			// 刷新 社区和站点
			rushData() {
				this.$emit('moduleZero', {
					k: 1,
					communityId: this.searchObj.communityId
				})
			},
			// 设备编辑请求
			updateCommunityEquipment() {
				let obj = {
					communityId: this.creatObj.communityId || "", //社区id
					communitySiteId: this.creatObj.communitySiteId || "", //站点id
					communityEquipmentNo: this.creatObj.communityEquipmentNo || "", //设备硬件编号
					communityEquipmentName: this.creatObj.communityEquipmentName || "", //设备名称
					communityEquipmentIp: this.creatObj.communityEquipmentIp || "", //设备ip
					equipmentJackNumber: this.creatObj.equipmentJackNumber || "", //设备插座
					equipmentServiceProvider: this.creatObj.equipmentServiceProvider || "", //设备运营商
					equipmentStatus: this.creatObj.equipmentStatus || "", //设备状态 1正常 2故障 3掉线
					equipmentRunStatus: this.creatObj.equipmentRunStatus || "", //设备运营状态 1未投用 2运营中 3已拆除
					communityEquipmentId: this.creatObj.communityEquipmentId || "", //设备id
					equipmentInstallTime: this.creatObj.equipmentInstallTime || "", //安装时间
					communitySiteName: this.creatObj.communitySiteName || "", //安装时间
					equipmentInstallStatus: this.creatObj.equipmentInstallStatus || 1 //安装时间
				}
				this.$api.updateCommunityEquipment(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '设备修改成功',
								type: 'success'
							});
							setTimeout(() => {
								// 刷新社区列表 和充电站   
								this.$emit('moduleOne', this.communityObj)
								this.getData({})

							}, 500)
						})
					}
				})
			},
			// 设备新增请求
			addCommunityEquipment() {
				let obj = {
					communityId: this.creatObj.communityId || "", //社区id
					communitySiteId: this.creatObj.communitySiteId || "", //站点id
					// communityEquipmentNo: this.creatObj.communityEquipmentNo || "", //设备硬件编号
					communityEquipmentName: this.creatObj.communityEquipmentName || "", //设备名称
					communityEquipmentIp: this.creatObj.communityEquipmentIp || "", //设备ip
					equipmentJackNumber: this.creatObj.equipmentJackNumber || "", //设备插座
					equipmentServiceProvider: this.creatObj.equipmentServiceProvider || "", //设备运营商
					equipmentStatus: this.creatObj.equipmentStatus || "", //设备状态 1正常 2故障 3掉线
					equipmentRunStatus: this.creatObj.equipmentRunStatus || "", //设备运营状态 1未投用 2运营中 3已拆除
					// equipmentInstallTime: this.creatObj.equipmentInstallTime || "" //安装时间
				}
				this.$api.addCommunityEquipment(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '新建设备成功',
								type: 'success'
							});
							setTimeout(() => {
								// 刷新社区列表 和充电站   
								this.getData({})
								this.rushData()
							}, 500)
						})
					}
				})
			},
			// 1编辑2运维记录3设备二维码4删除
			itemClick(item, n) {
				let that = this
				if (n == 1) {
					this.openDia(n, item)
				} else if (n == 2) {
					this.$emit("goUrl", item, "/hitchManage")
					// this.getoperationData()
				} else if (n == 3) {
					this.createQRCode(n, item)

				} else if (n == 4) {
					this.$confirm('是否确认删除该设备?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.deleteCommunityEquipment({
							communityEquipmentId: item.communityEquipmentId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
								setTimeout(() => {
									this.getData({})
									this.rushData()
								}, 500)
							}
						})
					}).catch(() => {

					});
				} else if (n == 5) {
					this.$confirm('是否确认解绑设备（' + item.communityEquipmentName + '）?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.unbindCommunityEquipment({
							communityEquipmentId: item.communityEquipmentId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '解绑成功!'
								});
								setTimeout(() => {
									this.getData({})
									this.rushData()
								}, 500)
							}
						})
					}).catch(() => {

					});
				} else if (n == 6) {
					this.$emit("goUrl", {
						communityEquipmentNo: item.communityEquipmentNo
					}, "/chargingManage")
				} else if (n == 7) {
					this.$confirm('是否确认复位设备（' + item.communityEquipmentName + '）?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.resetCommunityEquipment({
							communityEquipmentId: item.communityEquipmentId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '复位成功!'
								});
								setTimeout(() => {
									this.getData({})
									this.rushData()
								}, 500)
							}
						})
					}).catch(() => {

					});
				} else if (n == 8) {
					console.log(item)
					this.$confirm('是否确认复位（' + item.communityEquipmentPort + '）号插口?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.resetCommunityEquipment({
							communityEquipmentId: item.communityEquipmentId,
							communityEquipmentPort: item.communityEquipmentPort
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '复位成功!'
								});
								setTimeout(() => {
									this.getselectCommunityEquipment(item.communityEquipmentId,item)
								}, 500)
							}
						})
					}).catch(() => {

					});
				} else if (n == 9) {
					this.visibleShow1 = true
					this.$set(this, "creatObj",item)
					this.$set(this.creatObj, "equipmentMaxPower", (JSON.parse(JSON.stringify(item)).equipmentMaxPower)/10)
					this.$set(this.creatObj, "equipmentMinPower", (JSON.parse(JSON.stringify(item)).equipmentMinPower)/10)
					this.$nextTick(() => {
						this.$refs.ruleForm5.clearValidate()
					})

				}
			},
			createQRCode(n, item) {
				this.$api.createQRCode({
					communityEquipmentId: item.communityEquipmentId
				}).then((res) => {
					if (res) {
						// 1方式
						const myBlob = new window.Blob([res], {
							type: 'image/jpeg'
						})
						// 2方式
						const qrUrl = window.URL.createObjectURL(myBlob)
						this.$set(this, "cardUrl", qrUrl)
						this.equipmentCard = true
					}
				})

			},
			// 获取设备列表
			getData(n) {
				console.log(n);
				this.loading = true
				if (n.communityId) {
					this.communityObj = n
					this.searchObj.communityId = n.communityId
					this.searchObj.pageNo = 1
					this.PageInfo.pagenum = 1
					this.searchObj.communityName = n.communityName
					this.searchObj.communitySiteId = ''
					this.searchObj.communityEquipmentNo = ''
					this.setStationList(n.communityId)
				} else {
					this.searchObj.communityId = this.searchObj.communityId
				}
				if (n.communitySiteId) {
					this.searchObj.communitySiteId = n.communitySiteId
				} else {
					this.searchObj.communitySiteId = this.searchObj.communitySiteId
				}
				let obj = {
					communityId: this.searchObj.communityId, //社区编号
					communitySiteId: this.searchObj.communitySiteId,
					communityEquipmentNo: this.searchObj.communityEquipmentNo,
					equipmentStatus: this.searchObj.equipmentStatus,
					equipmentRunStatus: this.searchObj.equipmentRunStatus,
					pageNo: this.searchObj.pageNo, //当前页
					pageSize: this.searchObj.pageSize, //当前页个数
				}
				this.$api.listCommunityEquipment(obj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						// res.obj.list[2].submitState = 1
						// res.obj.list[4].submitState = 2
						this.$set(this, "tableData", res.obj.list)
						this.$set(this.PageInfo, "total", res.obj.total)
						this.$nextTick(() => {
							for (let j of this.selectionArr) {
								for (let k of this.tableData) {
									if (k.communityEquipmentId == j) {
										this.$refs.multipleTable.toggleRowSelection(k, true);
									}
								}
							}


						})
					}
				})

			},
			// 选择分页
			handleCurrentChange(val, n) {
				if (n == 1) {
					this.$set(this.PageInfo, "pagenum", val)
					this.$set(this.searchObj, "pageNo", val)
					this.getData({})
				} else {
					this.OperationObj.pageNo = val
					this.getoperationData(val)
				}

			},
			// 搜索
			toSearch() {
				this.searchObj.pageNo = 1
				this.PageInfo.pagenum = 1
				if (this.searchObj.search) {}
				this.getData({})
			},
			onSuccess(n) {
				let that = this
				if (n.returnCode == 200) {
					that.$message({
						type: 'success',
						message: '上传成功!'
					});
					setTimeout(() => {
						that.getData({})
						that.rushData()
					}, 500)
				}

			},
			beforeUpload(file) {
				console.log(file)
			},
			onError(res) {
				this.$message({
					message: "上传失败",
					type: 'error'
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./equipmentManagement.scss"
</style>